import { combineEpics } from 'redux-observable';

import { _reducer } from './studentRoster.reducers';
import _epics from './studentRoster.epics';

export const epics = combineEpics(_epics);
export { _reducer };
export * from './studentRoster.actions';
export * from './studentRoster.utils';
